export default class overlayTip{

}
